import RichText from "./RichText";
import hocWithBaseElementWrap from '../../utils/hocWithBaseElementWrap';
export default hocWithBaseElementWrap(RichText);